import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SideMenu from '../SideMenu';


function Header({ page }) {
  const navigate = useNavigate(); // Initialize the navigate function
  const isAuthenticated = localStorage.getItem('auth_token')
  const [showMenu, setShowMenu] = useState(false)

  const handleLogoClick = () => {
    navigate('/'); // Navigate to the root route (Firstpage)
  };

  const handleRegisterClick = () => {
    navigate('/Login')
  }
  const handleViewReportsClick = () => {
    navigate('/ViewReports')
  }
  return (
      <header>
        <div className="logo">
          <Link to={'/'}>
            <img src="/images/logo.png" alt="" />
          </Link>
        </div>
        <div className="menu">
          <Link className={`menu_item ${ page == 'home' ? 'active' : '' }`} to={'/'}>მთავარი</Link>
          <Link className={`menu_item ${ page == 'catalog' ? 'active' : '' }`} to={'/catalog'}>კატალოგი</Link>
          <Link className={`menu_item ${ page == 'about' ? 'active' : '' }`} to={'/about'}>ჩვენს შესახებ</Link>
        </div>
        <div className="social">
          <a href="https://www.facebook.com/@SkyHookGeorgia" target='_blank'>
            <img src="/images/fb.png" alt="" />
          </a>
          <a href="https://www.instagram.com/skyhookgeorgia" target='_blank'>
            <img src="/images/instagram.png" alt="" />
          </a>
          <Link className={`menu_item tel_item ${ page == 'about' ? 'active' : '' }`} to={'tel:+995598666022'}>
            <img src="/images/tel.png" alt="" /> <p>598 666 022</p>
          </Link>
        </div>
        <div className="sm_menu" onClick={() => setShowMenu(!showMenu)}>
          <img src={`/images/${ showMenu ? 'close' : 'more'}.png`} alt="" />
        </div>

        {showMenu && <SideMenu />}
        
      </header>
  )
}

export default Header